import React from 'react';
import { User, Store } from 'lucide-react';

const ROLES = [
  { id: 'buyer', label: 'Shopper agent', hint: 'Acts for a person or business that is buying.', Icon: User },
  { id: 'seller', label: 'Seller agent', hint: 'Acts for a retailer: answers, sells, or handles claims.', Icon: Store },
];

export function AgentRoleFields({ form, setForm }) {
  return (
    <div className="space-y-3" data-testid="reg-role-fields">
      <label className="block text-xs text-gray-400">Agent role</label>
      <div className="grid sm:grid-cols-2 gap-2">
        {ROLES.map(({ id, label, hint, Icon }) => (
          <button key={id} type="button" onClick={() => setForm({ ...form, agent_role: id, merchant_domain: id === 'buyer' ? '' : form.merchant_domain })}
            className={`text-left rounded-lg border px-3 py-2.5 transition-colors ${form.agent_role === id ? 'border-red-400/60 bg-red-500/10' : 'border-white/10 bg-white/5 hover:border-white/25'}`}
            data-testid={`reg-role-${id}`}>
            <span className="flex items-center gap-2 text-sm text-white"><Icon className="w-4 h-4" /> {label}</span>
            <span className="block text-[11px] text-gray-500 mt-0.5">{hint}</span>
          </button>
        ))}
      </div>
      {form.agent_role === 'seller' && (
        <div className="space-y-2">
          <label className="block text-xs text-gray-400">Retailer domain this agent represents *</label>
          <input required value={form.merchant_domain} onChange={(e) => setForm({ ...form, merchant_domain: e.target.value })} placeholder="shop.example"
            className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white font-mono focus:border-red-500 focus:outline-none" data-testid="reg-merchant-domain" />
          <p className="text-[11px] text-sky-200/80 leading-relaxed" data-testid="reg-seller-notice">
            The operator enrolls itself. Kojiru never lists an agent on someone else's behalf. Use one listing, with its own wallet, for each retailer. The profile shows "Domain confirmed" only after the retailer lists this wallet in the agents list of https://your-domain/.well-known/claim-records.json.
          </p>
        </div>
      )}
    </div>
  );
}
